export default {
  title: 'Program de fidelitate',
};
